import React from 'react';
import NumberFormat from "react-number-format";
import RefreshButton from "../../../utils/RefreshButton";
import SweetAlert from "react-bootstrap-sweetalert";
import Ticket58 from "../print/ticket58";
import {useLotto99} from "../../../store/lotto99/Lotto99Context";
import RecentTicketRowMobile from "./RecentTicketRowMobile";

const RecentTicketMobile = () => {

    const {t, size, onChangeSize, onFilter, imageRotate, tickets, isShow, onCloseDetail, dataDetail} = useLotto99()
    return (
        <div className="lotto99">
            <div
                className="col no-padding-div header-div-title header-text header-div-blue-light block-header position-static border-b-1 d-flex align-items-center">
                    <span className="text-black kh-font-bold ">{t("labels:common.recentBet")}
                        <NumberFormat
                            className="in-recent-size"
                            isAllowed={({value}) => value < 11}
                            onBlur={() => {
                                if (size > 0 && size < 11) onFilter()
                                else onChangeSize(3)
                            }}
                            onValueChange={({floatValue}) => onChangeSize(floatValue)}
                            value={size}/>
                                        <span>
                                            {t("labels:common.draw")}
                                        </span>
                                </span>

                <div className="d-flex align-item-center mr-2">
                    <RefreshButton
                        onClick={() => onFilter()}
                        className={imageRotate}
                    />
                </div>

            </div>
            {/*{!isNewFormat && <OldRecentTicketRow onShowDetail={this.onShowDetail} t={t} tickets={tickets}/>}*/}

            {tickets && <RecentTicketRowMobile/>}

            <SweetAlert
                title=""
                show={isShow}
                onConfirm={onCloseDetail}
                confirmBtnText={t("labels:common.close")}
                showCancel={false}
                btnSize="lg"
            >
                <div className='d-flex justify-content-center'>
                    <Ticket58
                        object={dataDetail}/>
                </div>
            </SweetAlert>

        </div>
    );
};

export default RecentTicketMobile;